import { debug } from "webpack";

function menuItemKeypressHandler() {
    const selector = '.product-menu > ul li';
    $(selector).off('keypress');
    $(selector).on('keypress', function(e) {
        if (e.keyCode !== 13) return;
        toggleMenu(e, this);
    });
}

function menuItemClickHandler() {
    const selector = '.product-menu > ul li';
    $(selector).off('click');
    $(selector).on('click', function(e) {
        toggleMenu(e, this);
    });
}

function productMenuButtonClickHandler() {
    const selector = '.product-menu-button';
    $(selector).off('click');
    $(selector).on('click', e => {
        $('.product-menu > ul').find('ul').hide();
        $('.product-menu > ul').find('.open').removeClass('open');
        $('.transparent-fill').show();
        $('.product-menu').show();
        $('body').css('overflow', 'hidden');
        e.preventDefault();
        $('.StockMenu').show();
    });
    
}

function profileMenuButtonClickHandler() {
    const selector = '.logged-in';
    $(selector).off('click');
    $(selector).on('click', e => {
        $('.transparent-fill').show();
        $('.user-menu').show();
        $('body').css('overflow', 'hidden');
        e.preventDefault();
    });
    $('.user-menu-close').on('click', e => {
        $('.transparent-fill').hide();
        $('.user-menu').hide();
        $('body').css('overflow', 'auto');
        e.preventDefault();
    });
    
}

function transparentFillClickHandler() {
    const selector = '.transparent-fill';
    $(selector).off('click');
    $(selector).on('click', function() {
        $(this).hide();
        $('.product-menu').hide();
        $('.user-menu').hide();
        $('.list-sidebar').removeClass('shown');
        $('.sort-wrapper .sort-container').css('display', 'none');
        $('body').css('overflow', 'auto');
        $('.news-sidebar').css('right', '-262px');
        $('.StockMenu').hide();
    });
}

function windowResizeHandlder() {
    $(window).off('resize');
    $(window).on('resize', () => {
        if ($('.product-menu-button').is(':visible')) {
            $('.transparent-fill').click();
        } else {
            $('.transparent-fill').click();
            $('.product-menu').show();
            $('.profile-menu').show();
            $('.StockMenu').show();
        }
    });
}

function toggleMenu(e, thisElement) {
    if (document.documentElement.clientWidth < 1200) {
        if (e.target !== thisElement || $(thisElement).children('a').hasClass('leaf')) {
            return;
        }

        if (!($(thisElement).hasClass('open'))) {
            $(thisElement).parent().children('.open').find('ul').hide();
            $(thisElement).parent().children('.open').find('.open').removeClass('open');
            $(thisElement).parent().children('.open').removeClass('open');
        }
        $(thisElement).children('ul').toggle();
        $(thisElement).toggleClass('open');
    }
}

function menuItemLinkClickHandler() {
    const selector = '.product-menu a';
    
    $(selector).off('click');
    $(selector).on('click', function (e) {
        firstLevelLink(e, this);
    });
    
}

function firstLevelLink(e, thisElement) {
    if ($(window).width() < 992) {
        if ($(thisElement).attr('href') == undefined) {
            $(thisElement).closest('li').toggleClass('open');
            $(thisElement).nextAll('ul').toggle();
        } else {
            return;
        }
        
    } else {
        return;
    }
    
}

function emptyPadding() {
    $('.product-menu > ul > li > ul > li').hover(function () {
        var ul = $(this).children('ul').children('li').html();
        if (!ul) {
            $(this).children('ul').css('padding', '0 20px');
        }
    }); 

    
}


const initMenu = () => {
    menuItemLinkClickHandler();
    menuItemKeypressHandler();
    menuItemClickHandler();
    productMenuButtonClickHandler();
    profileMenuButtonClickHandler();
    transparentFillClickHandler();
    windowResizeHandlder();
    emptyPadding();
};

export {
    initMenu
};
